
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.11628',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.11628",
  "apollo-dlb": "static-3.80",
  "client-types": "static-1.450",
  "dashboard-client-types": "static-1.248",
  "data-fetching-client": "static-1.9505",
  "foundations-components": "static-1-jhardy-popover-allow-cross-axis-shift.9",
  "foundations-components-legacy": "static-1-jhardy-popover-allow-cross-axis-shift.9",
  "foundations-theming": "static-1.4238",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.78",
  "head-dlb": "static-1.4841",
  "hs-test-utils": "static-1.7833",
  "hub-http-shared-msw-handlers": "static-1.9532",
  "hubspot-dlb": "static-2.1806",
  "hubspot-url-utils": "static-1.3957",
  "HubStyleTokens": "static-2.11263",
  "I18n": "static-7.1580",
  "jasmine-runner": "static-1.6298",
  "marketplace-storefront-base": "static-1.11688",
  "quartz": "static-1.6771",
  "react-dlb": "static-1.73",
  "react-rhumb": "static-1.16479",
  "react-router-dom": "static-5.26",
  "reactive-variable-buffer-atom": "static-1.2690",
  "reporting-testing-lib": "static-1.8560",
  "settings-ui-lib": "static-1.12350",
  "SharedI18nStrings": "static-1.180",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.6781",
  "ui-addon-i18n": "static-1.10971",
  "ui-addon-react-router-dom": "static-1.9373",
  "unified-auth": "static-1.249",
  "unified-auth-core-lib": "static-1.530",
  "usage-tracker": "static-1.7163",
  "usage-tracker-core": "static-1.7013",
  "customer-data-property-utils": "static-1.7907",
  "history": "static-4.47",
  "hub-http": "static-1.6046",
  "integrations-lib": "static-1.15497",
  "marketplace-ui-common": "static-1.19014",
  "property-management-iframe": "static-1.12432",
  "quartz-config": "static-1.549",
  "quartz-core": "static-1.5990",
  "quartz-routing": "static-1.201",
  "quick-fetch": "static-1.3763",
  "react": "static-7.180",
  "rpc-client-utils": "static-1.4462",
  "ts-schema": "static-1.3931",
  "ui-universal-auth": "static-1.8735",
  "UIComponents": "static-3.8210",
  "apollo-stack-hubspot": "static-3.79",
  "enviro": "static-4.405",
  "hs-promise-rejection-tracking": "static-1.5387",
  "PortalIdParser": "static-2.367",
  "raven": "static-3.5725",
  "raven-hubspot": "static-1.6032",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.19",
  "metrics-js": "static-1.9436",
  "react-redux": "static-7.67",
  "redux": "static-4.16",
  "styled-components": "static-2.85",
  "bend-plugin-trellis-migration": "static-1.3254",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3048",
  "quartz-webpack": "static-1.2995",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1-jhardy-popover-allow-cross-axis-shift.9",
  "floating-ui": "static-1.52",
  "foundations-assets": "static-1.4664",
  "foundations-theming-specialty": "static-1.1954",
  "framer-motion": "static-1.68",
  "hs-story-utils": "static-1.9254",
  "react-aria": "static-1.62",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5200",
  "react-virtualized": "static-2.95",
  "StyleGuideUI": "static-3.484",
  "tanstack-table": "static-1.51",
  "trellis-assets": "static-1.1292",
  "ui-fonts": "static-1.525",
  "ui-images": "static-2.1104",
  "bend-plugin-foundations-theming": "static-1.2721",
  "foundations-theming-base": "static-1.3223",
  "stylex": "static-1.28",
  "HeadJS": "static-2.717",
  "hs-test-utils-bend-plugin": "static-1.2944",
  "msw": "static-1.39",
  "testing-library": "static-1.148",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.217",
  "moment-timezone": "static-5.79",
  "jasmine": "static-4.4153",
  "ai-components-ui-library": "static-1.8415",
  "ai-rendering-library": "static-1.9377",
  "chirp-fetch": "static-1.1710",
  "connections-embed-lib": "static-1.673",
  "copilot-toolkit": "static-1.10595",
  "laboratory-lib": "static-3.6987",
  "marketplace-embed": "static-1.21536",
  "marketplace-ui-details": "static-1.8910",
  "marketplace-ui-reviews": "static-1.18970",
  "marketplace-ui-tracking": "static-1.13185",
  "sanitize-text": "static-1.7972",
  "ui-addon-video-player": "static-1.8523",
  "usage-tracker-multi": "static-1.5577",
  "usage-tracker-session-replay": "static-1.4849",
  "wootric-nps": "static-1.6812",
  "apollo-link-hub-http": "static-2.4479",
  "immer": "static-1.33",
  "immerable": "static-1.3982",
  "highcharts": "static-8.100",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2387",
  "reporting-data": "static-1.66627",
  "cssUtils": "static-1.744",
  "flux-actions": "static-1.311",
  "HubStyle": "static-2.11571",
  "PatternValidationJS": "static-1.437",
  "react-colorpicker": "static-2.10038",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10200",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7153",
  "icons": "static-2.624",
  "marketplace-ui-apps-core": "static-1.17547",
  "storybook-react": "static-1.29",
  "trellis-story-utils": "static-1.4348",
  "foundations-components-test-utils": "static-1-jhardy-popover-allow-cross-axis-shift.9",
  "quartz-i18n": "static-1.446",
  "react-input-autosize": "static-2.17",
  "fsm": "static-1.3558",
  "customer-data-objects": "static-1.7475",
  "property-translator": "static-1.5238",
  "frontend-preferences-client": "static-1.7752",
  "hs-promise-utils": "static-1.5421",
  "hubspot-apollo-client": "static-1.4708",
  "integrations-error-boundary-lib": "static-1.12912",
  "integrations-tracking-lib": "static-1.5415",
  "native-integrations-shared-strings": "static-1.7616",
  "reselect": "static-2.16",
  "sanitize": "static-1.4302",
  "superstore": "static-1.4598",
  "ui-shepherd-react": "static-3.9974",
  "ai-settings-ui-library": "static-1.7538",
  "hub-http-janus": "static-1.803",
  "hubspotter-http": "static-1.4504",
  "immutable-less": "static-1.4482",
  "marketplace-ui-client-types": "static-1.16421",
  "nav-meta": "static-1.28985",
  "react-window": "static-1.13",
  "self-service-api": "static-1.10067",
  "ui-addon-upgrades": "static-9.17695",
  "inbound-db-properties-service-client": "static-1.3701",
  "property-management-common": "static-1.4719",
  "ui-addon-iframeable": "static-1.8874",
  "dispatcher": "static-1.132",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.491",
  "module-federation": "static-1.19",
  "quartz-auth": "static-1.446",
  "quartz-head": "static-1.436",
  "quartz-test": "static-1.446",
  "quartz-tracking": "static-1.150",
  "csstype": "static-1.50",
  "bender-build-tools": "static-1.2970",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.20436",
  "ContentUtils": "static-1.67690",
  "sassPrefix": "static-1.152",
  "avatar-components": "static-1.2316",
  "customer-data-filters-ui": "static-1.38989",
  "customer-data-objects-ui-components": "static-1.12836",
  "customer-data-reference-ui-components": "static-1.12974",
  "embedded-academy-lib": "static-1.13633",
  "ExportDialog": "static-6.10214",
  "highlight.js": "static-1.75",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.40717",
  "reporting-snowflake": "static-1.55245",
  "reporting-ui-components": "static-2.63898",
  "reporting-visualizations": "static-1.58703",
  "ui-addon-teams": "static-1.21277",
  "magpie-lib": "static-1.5422",
  "magpie-types": "static-1.4882",
  "simple-logging-lib": "static-1.2878",
  "navigation-components": "static-1.17348",
  "ai-studio-lib": "static-1.11061",
  "developer-experience-shared-components": "static-1.10317",
  "transmute": "static-2.85",
  "ui-addon-integrations-directory-panel": "static-2.7817",
  "ui-tool-access": "static-1.9973",
  "usage-based-billing-components-lib": "static-1.8072",
  "usage-tracker-anonymous": "static-1.5580",
  "usage-tracker-public": "static-1.6974",
  "amplitude-session-replay-browser": "static-1.56",
  "inbound-db-meta-service-client": "static-1.3447",
  "persist-promise": "static-1.3535",
  "reference-resolvers": "static-1.7989",
  "ui-extensibility-client-types": "static-1.3771",
  "hubspot-apollo-cache": "static-1.167",
  "universal-page-editor-lib": "static-1.2827",
  "redux-toolkit": "static-1.7",
  "simple-data-table": "static-1.2247",
  "merchandise-lib": "static-1.260",
  "atom": "static-1.4897",
  "purchase-motions-components": "static-1.5517",
  "salesImages": "static-1.521",
  "batch-promise": "static-1.1378",
  "crm-component-utils": "static-1.38531",
  "crm-properties-common-lib": "static-1.5699",
  "customer-data-properties": "static-1.50860",
  "framework-data-schema-resolvers": "static-1.6700",
  "reference-resolvers-lite": "static-1.7922",
  "navigation-messaging": "static-1.6675",
  "hubspotter-http-shared-msw-handlers": "static-1.9530",
  "cms-field-types": "static-1.4634",
  "content-icons-ui": "static-1.2167",
  "conversations-skeleton-state": "static-1.7076",
  "crm-message-bus": "static-1.42433",
  "customer-data-filters-ui-msw-helpers": "static-1.21424",
  "customer-data-ui-utilities": "static-1.9651",
  "FormUrlGenerator": "static-2.4555",
  "framework-builder-read-service-client": "static-1.3860",
  "framework-data-schema-quick-fetch": "static-1.6605",
  "multi-account-reference-resolvers": "static-1.800",
  "onboarding-tours": "static-1.16301",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.13126",
  "academy-common-lib": "static-1.13093",
  "content-assistance-lib": "static-1.7486",
  "dashboard-lib": "static-1.80724",
  "file-manager-components": "static-1.22973",
  "getting-started-shared-tasks": "static-1.17947",
  "hubspot-prosemirror": "static-1.17667",
  "hubspot-prosemirror-plugins": "static-1.17659",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.19515",
  "share-with-third-party-component-lib": "static-1.8521",
  "ui-addon-draggable": "static-3.4594",
  "ui-asset-management-lib": "static-1.10744",
  "ui-business-units-lib": "static-1.8857",
  "user-context": "static-1.4927",
  "growth-payments-core": "static-1.24790",
  "reporting-plugins": "static-1.10019",
  "reporting-reports": "static-1.66305",
  "idb-keyval": "static-1.40",
  "reactive-lib": "static-1.552",
  "codemirror": "static-5.91",
  "feedback-loader": "static-1.28907",
  "react-codemirror": "static-1.10453",
  "apps-service-types": "static-1.3705",
  "oauth-service-types": "static-1.4074",
  "onboarding-scopes": "static-1.6290",
  "onboarding-tours-client": "static-1.4515",
  "platform-infra-nav-components": "static-1.7518",
  "subscription-experience-data-types": "static-1.14616",
  "crm-record-cards-service-types": "static-1.3470",
  "location-customization-utils-lib": "static-1.8634",
  "redux-thunk": "static-2.43",
  "growth-monetization-service-types": "static-1.4329",
  "nav-client-types": "static-1.2185",
  "purchase-motions-api": "static-1.5520",
  "signup-constants": "static-1.18472",
  "signup-ui-url-generator": "static-2.7861",
  "trials-service-types": "static-1.3730",
  "card-properties-lib": "static-1.43589",
  "commerce-subscription-lib": "static-1.36512",
  "crm-actions": "static-1.6133",
  "crm-cards-data": "static-1.1263",
  "crm-cards-sdk": "static-1.42990",
  "customer-data-properties-shared-msw-handlers": "static-1.8859",
  "customer-data-tracking": "static-1.6708",
  "calling-global-api": "static-1.63760",
  "calling-internal-common": "static-1.31122",
  "calling-lifecycle-internal": "static-1.65142",
  "calling-lifecycle-messages": "static-1.57436",
  "commerce-products-lib": "static-1.8925",
  "conditional-properties-service-client": "static-1.3649",
  "crm-links": "static-1.6094",
  "external-options-client-types": "static-1.4011",
  "google-libphonenumber": "static-1.34",
  "hs-entities": "static-1.507",
  "inbounddb-objects-service-types": "static-1.4074",
  "meetings-icalendar-utils-lib": "static-1.460",
  "multi-currency-client-types": "static-1.3542",
  "object-builder-ui-client": "static-1.48074",
  "pipeline-validation-client-types": "static-1.3815",
  "property-value-citations": "static-1.1474",
  "pulse": "static-1.343",
  "smart-property-lib": "static-1.6020",
  "tiered-pricing": "static-1.867",
  "ui-addon-form-validation": "static-1.10822",
  "crm-pipelines-api-client-types": "static-1.3992",
  "react-dnd-compat": "static-1.4447",
  "react-immutable-render-mixin": "static-1.9",
  "growth-data-modal": "static-1.5186",
  "growth-onboarding-confetti": "static-1.2900",
  "growth-onboarding-next-action-utils": "static-1.1351",
  "onboarding-tours-utils": "static-1.367",
  "ui-shepherd-tracker": "static-1.7355",
  "academy-service-client": "static-1.3507",
  "final-form": "static-1.66",
  "zustand": "static-1.51",
  "ui-coaching-tips": "static-1.28004",
  "redux-actions": "static-3.7",
  "ui-addon-opt": "static-4.8212",
  "video-components-external": "static-1.10639",
  "video-data-lib": "static-1.34297",
  "emoji-mart": "static-3.4",
  "knowledge-content-types": "static-1.8394",
  "payment-link-components": "static-1.23004",
  "ui-addon-emoji-picker": "static-1.9714",
  "EmailSignatureEditor": "static-1.23963",
  "viral-links-lib": "static-1.6864",
  "data-token-picker": "static-1.16088",
  "FileManagerLib": "static-1.38613",
  "react-flip-move": "static-1.66",
  "timezone-utils": "static-2.5072",
  "getting-started-shared-tasks-store": "static-1.17065",
  "campaign-roi-lib": "static-1.8347",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "edison-service-client-types": "static-1.220",
  "eligibility-engine-service-types": "static-1.3011",
  "crm_data": "static-4.91302",
  "customer-data-sidebar": "static-2.45480",
  "enrichment-properties-lib": "static-1.15138",
  "commerce-billing-lib": "static-1.18561",
  "commerce-shared-components-lib": "static-1.18009",
  "commerce-tools-ui-lib": "static-1.9855",
  "crm-fe-perf": "static-1.22733",
  "calling-error-reporting": "static-1.31128",
  "shared-worker-versioning": "static-1.10866",
  "calling-usage-tracker": "static-1.6368",
  "voice-sms-access-library": "static-1.310",
  "commerce-permissions": "static-1.587",
  "products-iframe-lib": "static-1.7391",
  "products-ui-components-shared-msw-handlers": "static-1.9914",
  "directed-graph": "static-1.767",
  "event-emitter": "static-1.774",
  "breeze-intelligence-kit": "static-1.5359",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9615",
  "policy-lib": "static-1.6607",
  "react-tinymce": "static-1.54685",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9678",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.53811",
  "tinymce-plugins": "static-1.56925",
  "tinymce-themes": "static-1.55781",
  "growth-onboarding-next-action-components": "static-1.1379",
  "user-context-client": "static-1.4477",
  "growth-onboarding-feedback-components": "static-1.6409",
  "content-media-composition-data-lib": "static-1.11545",
  "content-media-compositions": "static-2.15552",
  "media-bridge-lib": "static-1.18610",
  "commerce-tours-lib": "static-1.5757",
  "growth-onboarding-reliability": "static-1.4914",
  "sales-checkout-service-client": "static-1.3495",
  "draft-convert": "static-2.68",
  "draft-extend": "static-3.71",
  "draft-js": "static-5.73",
  "draft-plugins": "static-2.21352",
  "sales-email-signature-service-client": "static-1.3671",
  "audio-components": "static-1.5650",
  "FileManagerCore": "static-1.38472",
  "FileManagerImages": "static-1.36124",
  "video-components": "static-1.12642",
  "crm_universal": "static-1.21705",
  "customer-data-email": "static-1.17715",
  "card-payment-highlight-lib": "static-1.36565",
  "card-subscription-highlight-lib": "static-1.38935",
  "commerce-contract-lib": "static-1.11275",
  "customer-data-content": "static-1.26918",
  "invoices-highlight-card-lib": "static-1.54105",
  "orders-highlight-card-lib": "static-1.20927",
  "products-highlight-card-lib": "static-1.17209",
  "project-storage": "static-1.4561",
  "quotes-highlight-card-lib": "static-1.71285",
  "crm-source-interpretation-lib": "static-1.5157",
  "utility-belt": "static-1.2368",
  "customer-data-associations": "static-1.7167",
  "framework-data-table": "static-2.11471",
  "payments-enrollment-embed-lib": "static-1.22085",
  "customer-data-rte": "static-1.32503",
  "cv-backend-services": "static-1.1514",
  "growth-onboarding-empty-states": "static-1.5404",
  "InboxConnectUtils": "static-4.14285",
  "payments-post-enroll-local-storage-lib": "static-1.4941",
  "qrcode-generator": "static-1.65",
  "quotes-client-types": "static-1.37374",
  "calling-orchestration-schema": "static-1.35087",
  "sales-views-client-types": "static-1.4114",
  "hub-http-contrib": "static-1.2870",
  "interframe": "static-3.4615",
  "tinymce-data": "static-1.39896",
  "ui-addon-sales-email": "static-1.5041",
  "layout-dnd-components": "static-1.12085",
  "layout-dnd-utils": "static-1.11060",
  "ui-brand-identity-lib": "static-1.14042",
  "NamespacedHubStyle": "static-2.8923",
  "hls.js": "static-1.35",
  "js-cookie": "static-1.18",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4358",
  "video-embed": "static-1.35131",
  "social-insights-client-types": "static-1.21427",
  "sequences-lib": "static-1.7728",
  "ui-gdpr-components": "static-1.10174",
  "products-ui-components": "static-1.39444",
  "quotes-ui-lib": "static-1.80005",
  "SalesContentIndexUI": "static-3.8940",
  "accounting-integrations-ui-components": "static-1.6764",
  "invoices-ui-lib": "static-1.54121",
  "commerce-products-api": "static-1.1993",
  "SafeStorage": "static-1.4231",
  "invoices-iframe-lib": "static-1.56179",
  "quotes-modal-lib": "static-1.101962",
  "deal-intel-decorators": "static-1.1338",
  "tanstack-virtual": "static-1.26",
  "stripe-embedded-components": "static-1.7178",
  "draft-content-plugins": "static-1.27769",
  "ContentData": "static-1.67765",
  "layout-data-lib": "static-1.9385",
  "outpost": "static-1.4031",
  "sequences-client-types-lib": "static-1.7585",
  "commerce-tax-lib": "static-1.344",
  "property-description-translator": "static-1.3684",
  "FireAlarmUi": "static-1.4358",
  "sales-templates-service-types-lib": "static-1.4018",
  "commerce-analytics-service-client": "static-1.3483",
  "totals-ui-components": "static-1.23057",
  "deal-intel-utils": "static-1.1342",
  "stripe-connect-js": "static-1.65",
  "advanced-menus-core": "static-1.14855",
  "advanced-menus-lib": "static-1.11826",
  "ui-memberships-settings-lib": "static-1.33508",
  "commerce-totals-service-types": "static-1.3666",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14854",
  "simple-menus-lib": "static-1.16371"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.11628",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "client-types": "/client-types/static-1.450",
  "dashboard-client-types": "/dashboard-client-types/static-1.248",
  "data-fetching-client": "/data-fetching-client/static-1.9505",
  "foundations-components": "/foundations-components/static-1-jhardy-popover-allow-cross-axis-shift.9",
  "foundations-components-legacy": "/foundations-components-legacy/static-1-jhardy-popover-allow-cross-axis-shift.9",
  "foundations-theming": "/foundations-theming/static-1.4238",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.78",
  "head-dlb": "/head-dlb/static-1.4841",
  "hs-test-utils": "/hs-test-utils/static-1.7833",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9532",
  "hubspot-dlb": "/hubspot-dlb/static-2.1806",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3957",
  "HubStyleTokens": "/HubStyleTokens/static-2.11263",
  "I18n": "/I18n/static-7.1580",
  "jasmine-runner": "/jasmine-runner/static-1.6298",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.11688",
  "quartz": "/quartz/static-1.6771",
  "react-dlb": "/react-dlb/static-1.73",
  "react-rhumb": "/react-rhumb/static-1.16479",
  "react-router-dom": "/react-router-dom/static-5.26",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.2690",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.8560",
  "settings-ui-lib": "/settings-ui-lib/static-1.12350",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.180",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.6781",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.10971",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9373",
  "unified-auth": "/unified-auth/static-1.249",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.530",
  "usage-tracker": "/usage-tracker/static-1.7163",
  "usage-tracker-core": "/usage-tracker-core/static-1.7013",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7907",
  "history": "/history/static-4.47",
  "hub-http": "/hub-http/static-1.6046",
  "integrations-lib": "/integrations-lib/static-1.15497",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.19014",
  "property-management-iframe": "/property-management-iframe/static-1.12432",
  "quartz-config": "/quartz-config/static-1.549",
  "quartz-core": "/quartz-core/static-1.5990",
  "quartz-routing": "/quartz-routing/static-1.201",
  "quick-fetch": "/quick-fetch/static-1.3763",
  "react": "/react/static-7.180",
  "rpc-client-utils": "/rpc-client-utils/static-1.4462",
  "ts-schema": "/ts-schema/static-1.3931",
  "ui-universal-auth": "/ui-universal-auth/static-1.8735",
  "UIComponents": "/UIComponents/static-3.8210",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.79",
  "enviro": "/enviro/static-4.405",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5387",
  "PortalIdParser": "/PortalIdParser/static-2.367",
  "raven": "/raven/static-3.5725",
  "raven-hubspot": "/raven-hubspot/static-1.6032",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.19",
  "metrics-js": "/metrics-js/static-1.9436",
  "react-redux": "/react-redux/static-7.67",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.85",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3254",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3048",
  "quartz-webpack": "/quartz-webpack/static-1.2995",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1-jhardy-popover-allow-cross-axis-shift.9",
  "floating-ui": "/floating-ui/static-1.52",
  "foundations-assets": "/foundations-assets/static-1.4664",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1954",
  "framer-motion": "/framer-motion/static-1.68",
  "hs-story-utils": "/hs-story-utils/static-1.9254",
  "react-aria": "/react-aria/static-1.62",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5200",
  "react-virtualized": "/react-virtualized/static-2.95",
  "StyleGuideUI": "/StyleGuideUI/static-3.484",
  "tanstack-table": "/tanstack-table/static-1.51",
  "trellis-assets": "/trellis-assets/static-1.1292",
  "ui-fonts": "/ui-fonts/static-1.525",
  "ui-images": "/ui-images/static-2.1104",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2721",
  "foundations-theming-base": "/foundations-theming-base/static-1.3223",
  "stylex": "/stylex/static-1.28",
  "HeadJS": "/HeadJS/static-2.717",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2944",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.148",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.217",
  "moment-timezone": "/moment-timezone/static-5.79",
  "jasmine": "/jasmine/static-4.4153",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8415",
  "ai-rendering-library": "/ai-rendering-library/static-1.9377",
  "chirp-fetch": "/chirp-fetch/static-1.1710",
  "connections-embed-lib": "/connections-embed-lib/static-1.673",
  "copilot-toolkit": "/copilot-toolkit/static-1.10595",
  "laboratory-lib": "/laboratory-lib/static-3.6987",
  "marketplace-embed": "/marketplace-embed/static-1.21536",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.8910",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.18970",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.13185",
  "sanitize-text": "/sanitize-text/static-1.7972",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8523",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5577",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4849",
  "wootric-nps": "/wootric-nps/static-1.6812",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4479",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.3982",
  "highcharts": "/highcharts/static-8.100",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2387",
  "reporting-data": "/reporting-data/static-1.66627",
  "cssUtils": "/cssUtils/static-1.744",
  "flux-actions": "/flux-actions/static-1.311",
  "HubStyle": "/HubStyle/static-2.11571",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-colorpicker": "/react-colorpicker/static-2.10038",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10200",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7153",
  "icons": "/icons/static-2.624",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.17547",
  "storybook-react": "/storybook-react/static-1.29",
  "trellis-story-utils": "/trellis-story-utils/static-1.4348",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1-jhardy-popover-allow-cross-axis-shift.9",
  "quartz-i18n": "/quartz-i18n/static-1.446",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "fsm": "/fsm/static-1.3558",
  "customer-data-objects": "/customer-data-objects/static-1.7475",
  "property-translator": "/property-translator/static-1.5238",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7752",
  "hs-promise-utils": "/hs-promise-utils/static-1.5421",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4708",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12912",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5415",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7616",
  "reselect": "/reselect/static-2.16",
  "sanitize": "/sanitize/static-1.4302",
  "superstore": "/superstore/static-1.4598",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.9974",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.7538",
  "hub-http-janus": "/hub-http-janus/static-1.803",
  "hubspotter-http": "/hubspotter-http/static-1.4504",
  "immutable-less": "/immutable-less/static-1.4482",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.16421",
  "nav-meta": "/nav-meta/static-1.28985",
  "react-window": "/react-window/static-1.13",
  "self-service-api": "/self-service-api/static-1.10067",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17695",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3701",
  "property-management-common": "/property-management-common/static-1.4719",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8874",
  "dispatcher": "/dispatcher/static-1.132",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.491",
  "module-federation": "/module-federation/static-1.19",
  "quartz-auth": "/quartz-auth/static-1.446",
  "quartz-head": "/quartz-head/static-1.436",
  "quartz-test": "/quartz-test/static-1.446",
  "quartz-tracking": "/quartz-tracking/static-1.150",
  "csstype": "/csstype/static-1.50",
  "bender-build-tools": "/bender-build-tools/static-1.2970",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.20436",
  "ContentUtils": "/ContentUtils/static-1.67690",
  "sassPrefix": "/sassPrefix/static-1.152",
  "avatar-components": "/avatar-components/static-1.2316",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.38989",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12836",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.12974",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.13633",
  "ExportDialog": "/ExportDialog/static-6.10214",
  "highlight.js": "/highlight.js/static-1.75",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.40717",
  "reporting-snowflake": "/reporting-snowflake/static-1.55245",
  "reporting-ui-components": "/reporting-ui-components/static-2.63898",
  "reporting-visualizations": "/reporting-visualizations/static-1.58703",
  "ui-addon-teams": "/ui-addon-teams/static-1.21277",
  "magpie-lib": "/magpie-lib/static-1.5422",
  "magpie-types": "/magpie-types/static-1.4882",
  "simple-logging-lib": "/simple-logging-lib/static-1.2878",
  "navigation-components": "/navigation-components/static-1.17348",
  "ai-studio-lib": "/ai-studio-lib/static-1.11061",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10317",
  "transmute": "/transmute/static-2.85",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.7817",
  "ui-tool-access": "/ui-tool-access/static-1.9973",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.8072",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5580",
  "usage-tracker-public": "/usage-tracker-public/static-1.6974",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.56",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3447",
  "persist-promise": "/persist-promise/static-1.3535",
  "reference-resolvers": "/reference-resolvers/static-1.7989",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3771",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.167",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2827",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "simple-data-table": "/simple-data-table/static-1.2247",
  "merchandise-lib": "/merchandise-lib/static-1.260",
  "atom": "/atom/static-1.4897",
  "purchase-motions-components": "/purchase-motions-components/static-1.5517",
  "salesImages": "/salesImages/static-1.521",
  "batch-promise": "/batch-promise/static-1.1378",
  "crm-component-utils": "/crm-component-utils/static-1.38531",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5699",
  "customer-data-properties": "/customer-data-properties/static-1.50860",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6700",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7922",
  "navigation-messaging": "/navigation-messaging/static-1.6675",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9530",
  "cms-field-types": "/cms-field-types/static-1.4634",
  "content-icons-ui": "/content-icons-ui/static-1.2167",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7076",
  "crm-message-bus": "/crm-message-bus/static-1.42433",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21424",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9651",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4555",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3860",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6605",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.800",
  "onboarding-tours": "/onboarding-tours/static-1.16301",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13126",
  "academy-common-lib": "/academy-common-lib/static-1.13093",
  "content-assistance-lib": "/content-assistance-lib/static-1.7486",
  "dashboard-lib": "/dashboard-lib/static-1.80724",
  "file-manager-components": "/file-manager-components/static-1.22973",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.17947",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17667",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17659",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.19515",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8521",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4594",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10744",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8857",
  "user-context": "/user-context/static-1.4927",
  "growth-payments-core": "/growth-payments-core/static-1.24790",
  "reporting-plugins": "/reporting-plugins/static-1.10019",
  "reporting-reports": "/reporting-reports/static-1.66305",
  "idb-keyval": "/idb-keyval/static-1.40",
  "reactive-lib": "/reactive-lib/static-1.552",
  "codemirror": "/codemirror/static-5.91",
  "feedback-loader": "/feedback-loader/static-1.28907",
  "react-codemirror": "/react-codemirror/static-1.10453",
  "apps-service-types": "/apps-service-types/static-1.3705",
  "oauth-service-types": "/oauth-service-types/static-1.4074",
  "onboarding-scopes": "/onboarding-scopes/static-1.6290",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4515",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7518",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.14616",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3470",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8634",
  "redux-thunk": "/redux-thunk/static-2.43",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4329",
  "nav-client-types": "/nav-client-types/static-1.2185",
  "purchase-motions-api": "/purchase-motions-api/static-1.5520",
  "signup-constants": "/signup-constants/static-1.18472",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7861",
  "trials-service-types": "/trials-service-types/static-1.3730",
  "card-properties-lib": "/card-properties-lib/static-1.43589",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.36512",
  "crm-actions": "/crm-actions/static-1.6133",
  "crm-cards-data": "/crm-cards-data/static-1.1263",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.42990",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.8859",
  "customer-data-tracking": "/customer-data-tracking/static-1.6708",
  "calling-global-api": "/calling-global-api/static-1.63760",
  "calling-internal-common": "/calling-internal-common/static-1.31122",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65142",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57436",
  "commerce-products-lib": "/commerce-products-lib/static-1.8925",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3649",
  "crm-links": "/crm-links/static-1.6094",
  "external-options-client-types": "/external-options-client-types/static-1.4011",
  "google-libphonenumber": "/google-libphonenumber/static-1.34",
  "hs-entities": "/hs-entities/static-1.507",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4074",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.460",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3542",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48074",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3815",
  "property-value-citations": "/property-value-citations/static-1.1474",
  "pulse": "/pulse/static-1.343",
  "smart-property-lib": "/smart-property-lib/static-1.6020",
  "tiered-pricing": "/tiered-pricing/static-1.867",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10822",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3992",
  "react-dnd-compat": "/react-dnd-compat/static-1.4447",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "growth-data-modal": "/growth-data-modal/static-1.5186",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2900",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1351",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.367",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7355",
  "academy-service-client": "/academy-service-client/static-1.3507",
  "final-form": "/final-form/static-1.66",
  "zustand": "/zustand/static-1.51",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28004",
  "redux-actions": "/redux-actions/static-3.7",
  "ui-addon-opt": "/ui-addon-opt/static-4.8212",
  "video-components-external": "/video-components-external/static-1.10639",
  "video-data-lib": "/video-data-lib/static-1.34297",
  "emoji-mart": "/emoji-mart/static-3.4",
  "knowledge-content-types": "/knowledge-content-types/static-1.8394",
  "payment-link-components": "/payment-link-components/static-1.23004",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9714",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.23963",
  "viral-links-lib": "/viral-links-lib/static-1.6864",
  "data-token-picker": "/data-token-picker/static-1.16088",
  "FileManagerLib": "/FileManagerLib/static-1.38613",
  "react-flip-move": "/react-flip-move/static-1.66",
  "timezone-utils": "/timezone-utils/static-2.5072",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17065",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8347",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "edison-service-client-types": "/edison-service-client-types/static-1.220",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.3011",
  "crm_data": "/crm_data/static-4.91302",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.45480",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.15138",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.18561",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.18009",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.9855",
  "crm-fe-perf": "/crm-fe-perf/static-1.22733",
  "calling-error-reporting": "/calling-error-reporting/static-1.31128",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10866",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6368",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.310",
  "commerce-permissions": "/commerce-permissions/static-1.587",
  "products-iframe-lib": "/products-iframe-lib/static-1.7391",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9914",
  "directed-graph": "/directed-graph/static-1.767",
  "event-emitter": "/event-emitter/static-1.774",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5359",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9615",
  "policy-lib": "/policy-lib/static-1.6607",
  "react-tinymce": "/react-tinymce/static-1.54685",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9678",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.53811",
  "tinymce-plugins": "/tinymce-plugins/static-1.56925",
  "tinymce-themes": "/tinymce-themes/static-1.55781",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1379",
  "user-context-client": "/user-context-client/static-1.4477",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6409",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11545",
  "content-media-compositions": "/content-media-compositions/static-2.15552",
  "media-bridge-lib": "/media-bridge-lib/static-1.18610",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5757",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4914",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3495",
  "draft-convert": "/draft-convert/static-2.68",
  "draft-extend": "/draft-extend/static-3.71",
  "draft-js": "/draft-js/static-5.73",
  "draft-plugins": "/draft-plugins/static-2.21352",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3671",
  "audio-components": "/audio-components/static-1.5650",
  "FileManagerCore": "/FileManagerCore/static-1.38472",
  "FileManagerImages": "/FileManagerImages/static-1.36124",
  "video-components": "/video-components/static-1.12642",
  "crm_universal": "/crm_universal/static-1.21705",
  "customer-data-email": "/customer-data-email/static-1.17715",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.36565",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.38935",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.11275",
  "customer-data-content": "/customer-data-content/static-1.26918",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.54105",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.20927",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.17209",
  "project-storage": "/project-storage/static-1.4561",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.71285",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5157",
  "utility-belt": "/utility-belt/static-1.2368",
  "customer-data-associations": "/customer-data-associations/static-1.7167",
  "framework-data-table": "/framework-data-table/static-2.11471",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.22085",
  "customer-data-rte": "/customer-data-rte/static-1.32503",
  "cv-backend-services": "/cv-backend-services/static-1.1514",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5404",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14285",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.4941",
  "qrcode-generator": "/qrcode-generator/static-1.65",
  "quotes-client-types": "/quotes-client-types/static-1.37374",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35087",
  "sales-views-client-types": "/sales-views-client-types/static-1.4114",
  "hub-http-contrib": "/hub-http-contrib/static-1.2870",
  "interframe": "/interframe/static-3.4615",
  "tinymce-data": "/tinymce-data/static-1.39896",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5041",
  "layout-dnd-components": "/layout-dnd-components/static-1.12085",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11060",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.14042",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8923",
  "hls.js": "/hls.js/static-1.35",
  "js-cookie": "/js-cookie/static-1.18",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4358",
  "video-embed": "/video-embed/static-1.35131",
  "social-insights-client-types": "/social-insights-client-types/static-1.21427",
  "sequences-lib": "/sequences-lib/static-1.7728",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10174",
  "products-ui-components": "/products-ui-components/static-1.39444",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.80005",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.8940",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.6764",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.54121",
  "commerce-products-api": "/commerce-products-api/static-1.1993",
  "SafeStorage": "/SafeStorage/static-1.4231",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.56179",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.101962",
  "deal-intel-decorators": "/deal-intel-decorators/static-1.1338",
  "tanstack-virtual": "/tanstack-virtual/static-1.26",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7178",
  "draft-content-plugins": "/draft-content-plugins/static-1.27769",
  "ContentData": "/ContentData/static-1.67765",
  "layout-data-lib": "/layout-data-lib/static-1.9385",
  "outpost": "/outpost/static-1.4031",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7585",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.344",
  "property-description-translator": "/property-description-translator/static-1.3684",
  "FireAlarmUi": "/FireAlarmUi/static-1.4358",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4018",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3483",
  "totals-ui-components": "/totals-ui-components/static-1.23057",
  "deal-intel-utils": "/deal-intel-utils/static-1.1342",
  "stripe-connect-js": "/stripe-connect-js/static-1.65",
  "advanced-menus-core": "/advanced-menus-core/static-1.14855",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11826",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33508",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3666",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14854",
  "simple-menus-lib": "/simple-menus-lib/static-1.16371"
}
};
